import cron from 'cron-validate';
import { enterpriseCronOptions } from 'app/constants';

export const checkEnterpriseCronWithYears = (value: string) => {
  return cron(value, {
    override: enterpriseCronOptions,
  }).isValid();
};
